import '../styles/popup.scss';
import { useState, useEffect } from 'react';

export const PopUpMessage = () => {
  const [ popUp, setPopUp ]  = useState(false);

  useEffect(() => {
    setTimeout(
      () => setPopUp(true),
      5000
    )
  }, []);

  const close = () => setPopUp(false);
 
  return (
    <>
      {popUp ? 
        <div className='pop-up'>
          <div className='pop-up-box'>
            <div className='img-pop-up'></div>
            <div className='content-pop-up'>
              <div className='pop-up-btn'>
                <button onClick={close}>X</button>
              </div>
              <div className='text-pop-up'>
                <span>Christmas Eve – December 24th</span>
                <h3>Holiday Hours Notice</h3>
                <span className='anexo'>
                  On December 24th, we will be open from <br /><strong>10:00 AM to 2:00 PM</strong>.
                  <br /> <br />
                  On December 25th, we will be <strong>closed</strong> for Christmas Day.
                </span>
              </div>
            </div>
          </div>
        </div> 
      : null}
    </>
  );
};
